import StudentInGroupForm from "./StudentInGroupForm";
import { STUDENT_GROUPS, DATATABLE_EXPORT } from "../../../../../../../Config/ApiUrl";

export const StudentInGroupSchema = {
	components: { StudentInGroupForm },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			STUDENT_GROUPS,
			selectedUrl: this.ENDPOINT,
			tableId: "center-table",
			rowData: {},
			formId: "center-form",
			tableColumns: [
				{
					title: "CLC ID No",
					type: "text",
					key: "clc_id_number",
				},
				{
					title: "First Name",
					type: "custom-html",
					key: "student_info",
					modifier: (value) => {
						return value?.name ?? "-";
					}
				},
				{
					title: "Last Name",
					type: "custom-html",
					key: "student_info",
					modifier: (value) => {
						return value?.surname ?? "-";
					}
				},
				{
					title: "Main Teacher",
					type: "custom-html",
					key: "main_teacher",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Student Care",
					type: "custom-html",
					key: "student_care",
					modifier: (value) => {
						return value?.full_name ?? "-";
					}
				},
				{
					title: "Start Date",
					type: "text",
					key: "start_date",
				},
				{
					title: "Start Week",
					type: "text",
					key: "start_week",
				},
				{
					title: "End Date",
					type: "text",
					key: "end_date",
				},
				{
					title: "End Week",
					type: "text",
					key: "end_week",
				}
			],
			ENDPOINT:  "", 
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "Center",
				url:  "", 
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						component: "app-add-modal",
						modalId: "center-form",
					},
				],
				showFilter: false,
				showSearch: false,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 10,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {
		/**
		 * Delete confirmed $emit Form confirmation modal
		 */
		onDelete() {
			let url = `${this.ENDPOINT}/${this.rowData.id}`;
			this.deleteLoader = true;
			this.axiosDelete(url)
				.then((response) => {
					this.deleteLoader = false;
					$("#demo-delete").modal("hide");
					this.onCancelDelete();
					this.$toastr.s(response.data.message);
					// this.searchAndSelectFilterOptions();
				})
				.catch(({ err }) => {})
				.finally(() => this.$hub.$emit(`reload-${this.tableId}`));
		},
		onCancelDelete() {
			this.deleteConfirmationModalActive = false;
			this.reSetData();
		},
		reSetData() {
			this.rowData = {};
			this.selectedUrl = "";
		},
	},
};
